<template>
  <div>
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Create Route53 Record
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <customer-dropdown v-model="customer" :customers="customers" />
        <br>
        <div class="form-group kt-form__group no-gutters">
          <label for="name">Record name for <em>*.{{ domain }}</em></label>
          <input id="name"
                 v-model="name"
                 type="text"
                 class="form-control kt-input"
                 placeholder="example: timbre">
          <span class="kt-form__help">Please enter a subdomain name (the part before domain only)</span>
        </div>
        <div class="form-group kt-form__group">
          <label style="padding-right: 10px;">Record Type</label>
          <div class="kt-radio-inline">
            <label class="kt-radio">
              <input v-model="type" type="radio"
                     name="newest_order"
                     value="A"> A
              <span />
            </label>
            <label class="kt-radio">
              <input v-model="type" type="radio"
                     name="oldest_order"
                     value="CNAME"> CNAME
              <span />
            </label>
          </div>
        </div>
        <div class="form-group kt-form__group no-gutters">
          <label for="value">Value/Route traffic to</label>
          <input id="value"
                 v-model="value"
                 type="text"
                 class="form-control"
                 :placeholder="value_placeholder">
          <span class="kt-form__help">Depending on type you can enter either IP, IPs (comma seperated), or a single canonical name.</span>
        </div>
        <div class="row mt-4">
          <button class="btn item-save-btn btn-ss-standout w-100" @click.prevent="save()">
            <span>
              <i class="la la-save" />
              <span>Create</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapWritableState } from "pinia";
import useAdminStore from "VueStore/admin/general";

import CustomerDropdown from "VueComponents/CustomerDropdown";

export default {
  components: {
    CustomerDropdown,
  },
  data: () => ({
    domain: window.route53_domain,
    name: '',
    type: 'A',
    value: '',
  }),
  computed: {
    ...mapWritableState(useAdminStore, [
      'customer',
      'customers',
    ]),
    value_placeholder() {
      if (this.type === 'A') {
        return '1.2.3.4 | 1.2.3.4,1.1.2.2';
      }
      return 'timbre.sharp-stream.com';
    },
  },
  beforeMount() {
    this.fetchCustomers();
  },
  methods: {
    ...mapActions(useAdminStore, [
      'fetchCustomers',
    ]),
    async save() {
      try {
        const res = (await axios.post(`/api/v1/admin/route53`, {
          'customer': this.customer.slug,
          'type': this.type,
          'name': this.name,
          'value': this.value,
        })).data;

        if (res.success) {
          toastr.success(res.data.message);
          window.location.href = "/admin/route53";
        } else {
          toastr.error(res.error.message);
        }
      } catch (err) {
        if (err.response) {
          toastr.error(err.response.data.errors.value[0]);
        } else {
          toastr.error('Unknown error occured!');
        }
      }
    },
  },

};

</script>
